import React from 'react';
import { SeparationType } from '../../enums/SeparationType';
import { ListOrders } from '../ListOrders/ListOrders';

interface IManageOrderBatchProps {
  separationType: SeparationType;
  listingOrders?: () => void;
}

const ManageOrderBatch: React.FC<IManageOrderBatchProps> = ({
  separationType,
  listingOrders
}) => {
  return (
    <ListOrders
      separationType={separationType}
      listingOrders={listingOrders}
    />
  );
}

export { ManageOrderBatch };